import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    SANCTION_TYPE_PEP,
    SANCTION_TYPE_PEP_ES,
    SANCTION_TYPE_WATCHB,
    SANCTION_TYPE_SANLST,
    SANCTION_TYPE_ES_EMBARGOS,
    SANCTION_TYPE_ES_FRONTEIRA_INTERNATIONAL,
    SANCTION_TYPE_SANCTION_LISTS
} from './../../constants';

export default class ContentSummary extends Component {

    static propTypes = {
        sanctionType: PropTypes.string
    };

    static defaultProps = {
        sanctionType: ''
    };

    render() {

        let component;
        switch(this.props.sanctionType) {
            case SANCTION_TYPE_PEP_ES:
            case SANCTION_TYPE_PEP:
                component = <div>
                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText1'/></b></div>
                                    <FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText2'/>
                                </div>

                                <div className="content-summary__info--rows">
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText3'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText4'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText5'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText6'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText7'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText8'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText9'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText10'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText11'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText12'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText13'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText14'/></b></div>
                                    <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText15'/></div>
                                </div>

                                <div className="content-summary__info--rows">
                                    <span><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText16'/>:</b></span>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText17'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText18'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText19'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText20'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText21'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText22'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText23'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText24'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.pepText25'/></li>
                                    </ul>
                                </div>
                            </div>;
                break;
            case SANCTION_TYPE_WATCHB:
                component = <div>

                    <div className="content-summary__info--rows">
                        <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText1'/></b></div>
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText2'/></div>
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText3'/></div>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText4'/>:</div>
                        <ul>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText5'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText6'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText7'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText8'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText9'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText10'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText11'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText12'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText13'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText14'/></li>
                        </ul>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText15'/></b></div>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText16'/></div>
                        <ul>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText17'/></li>
                        </ul>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText18'/></div>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText19'/></div>
                        <ul>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText20'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText21'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText22'/></li>
                        </ul>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText23'/></div>
                        <ul>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText24'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText25'/></li>
                        </ul>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText26'/></b></div>
                    </div>

                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText27'/></div>
                        <ul>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText28'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText29'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText30'/></li>
                            <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.watchbText31'/></li>
                        </ul>
                    </div>

                </div>;
                break;
            case SANCTION_TYPE_SANLST:
                component = <div>
                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText1'/></b></div>
                                    <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText2'/></div>
                                </div>

                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText3'/></b></div>
                                    <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText4'/></div>
                                </div>

                                <div className="content-summary__info--rows">
                                    <span><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText5'/>:</span>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText6'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText7'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText8'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText9'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText10'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText11'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText12'/></b></div>
                                </div>

                                <div className="content-summary__info--rows">
                                    <FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText13'/>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText14'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText15'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <span><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText16'/></span>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText17'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText18'/>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText19'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText20'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText21'/>
                                    <ul>
                                       <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText22'/></li>
                                       <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText23'/></li>

                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText24'/></b></div>
                                    <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanlstText25'/></div>
                                </div>

                            </div>;

                break;

            case SANCTION_TYPE_SANCTION_LISTS:
                component = <div>
                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText1'/></b></div>
                                    <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText2'/></div>
                                </div>

                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText3'/></b></div>
                                    <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText4'/></div>
                                </div>

                                <div className="content-summary__info--rows">
                                    <span><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText5'/>:</span>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText6'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText7'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText8'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText9'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText10'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText11'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText12'/></b></div>
                                </div>

                                <div className="content-summary__info--rows">
                                    <FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText13'/>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText14'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText15'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <span><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText16'/></span>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText17'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText18'/>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText19'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText20'/></li>
                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText21'/>
                                    <ul>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText22'/></li>
                                        <li><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText23'/></li>

                                    </ul>
                                </div>

                                <div className="content-summary__info--rows">
                                    <div><b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText24'/></b></div>
                                    <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.sanctionListsText25'/></div>
                                </div>

                            </div>;

                break;
            case SANCTION_TYPE_ES_EMBARGOS:
                component = <div>
                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.embargosText1'/></div>
                    </div>
                </div>;

                break;
            case SANCTION_TYPE_ES_FRONTEIRA_INTERNATIONAL:
                component = <div>
                    <div className="content-summary__info--rows">
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary.fronteiraText1'/></div>
                    </div>
                </div>;

                break;
            default:
                component = <div>{this.props.sanctionType}</div>;
                break;
        }

        return (

            <div className="content-summary__info">

                {component}

            </div>


        );

    };

}



// WEBPACK FOOTER //
// ./src/scripts/pages/SanctionReports/SanctionReports.SanctionType.ContentSummary.jsx